export default __webpack_public_path__ + "static/media/about1.9f76d348.png";